module.exports = __webpack_public_path__ + "img/dashboard_bg.77915928.png";